export default "__VITE_ASSET__Bs1d8d3h__"